import { useRef, useImperativeHandle, forwardRef } from 'react'
import { SearchInputProps } from './SearchInput.types'
import { Container, Input, ClearButton } from './SearchInput.styles'

export interface SearchInputRef {
  focus: () => void
  blur: () => void
  clear: () => void
}

export const SearchInput = forwardRef<SearchInputRef, SearchInputProps>(
  (
    {
      value,
      onChange,
      placeholder = 'Search...',
      disabled = false,
      className,
      style,
      autoFocus = false,
      onClear,
      clearable = true,
    },
    ref
  ) => {
    const inputRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(ref, () => ({
      focus: () => inputRef.current?.focus(),
      blur: () => inputRef.current?.blur(),
      clear: () => {
        onChange('')
        onClear?.()
      },
    }))

    const handleClear = () => {
      onChange('')
      onClear?.()
      inputRef.current?.focus()
    }

    const showClearButton = clearable && value && !disabled

    return (
      <Container className={className} style={style}>
        <Input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          autoFocus={autoFocus}
          style={{ paddingRight: showClearButton ? '28px' : undefined }}
        />
        {showClearButton && (
          <ClearButton
            type="button"
            onClick={handleClear}
            title="Clear search"
            tabIndex={-1}
          >
            ×
          </ClearButton>
        )}
      </Container>
    )
  }
)

SearchInput.displayName = 'SearchInput'
